
export var getPageViewData = function(trackingJsonPV,goTo) {
	var categoryIdTrack = "";
	var extraParmsTrack = "";
	var priceReducedTrack = "";
	var seoColorTrack = "";
	var productCountTrack = "";
	var pageNameTrack = "";
	var contentTrack = "";
	var seoTitleTrack = "";
	var pageIdTrack = "";
	if(trackingJsonPV){
		pageIdTrack = trackingJsonPV.attributes.pageIdTrack;
		categoryIdTrack = trackingJsonPV.attributes.categoryIdTrack;
		extraParmsTrack = trackingJsonPV.attributes.extraParmsTrack;
		priceReducedTrack = trackingJsonPV.attributes.priceReducedTrack;
		seoColorTrack = trackingJsonPV.attributes.seoColorTrack;
		productCountTrack = trackingJsonPV.attributes.productCountTrack;
		pageNameTrack = trackingJsonPV.attributes.pageNameTrack;
		contentTrack = trackingJsonPV.attributes.contentTrack;
		seoTitleTrack = trackingJsonPV.attributes.seoTitleTrack;
	}
	dataLayer.page = dataLayer.page ? dataLayer.page : {};
	dataLayer.page.pageTime = getFormattedTS();
	var realSearch = "";
	if(dataLayer.page.RealSearch) {
		realSearch = dataLayer.page.RealSearch;
	}
	var getQueryParameterValue = function(variable) {
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		for (var i=0;i<vars.length;i++) {
	    var pair = vars[i].split("=");
	    if(pair[0] == variable){
	    	return pair[1];};
		}
		return(pair[1]);
	};
	var trackAsSearch = getQueryParameterValue('trackAsSearch');
	if(goTo == 1) {
		if(realSearch === 'Y' || trackAsSearch) {
			dataLayer.page.pageId = "SEARCH: Results Successful";
		} else if(realSearch === 'N' || !trackAsSearch || !realSearch) {
			var pageName = pageNameTrack + " Landing Page";
			dataLayer.page.pageId = pageName;
			dataLayer.page.categoryId = "-10032";
		}
	} 
	if(goTo == 2) {
		if(realSearch === 'Y' || trackAsSearch) {
			realSearch = 'Y';
			dataLayer.page.pageId = "SEARCH: Results Successful";
		} else if(realSearch === 'N' || !trackAsSearch || !realSearch) {
			realSearch = 'N';
			dataLayer.page.pageId = pageIdTrack;
		};
	}
	if(goTo == 3) {
		var pageName = "";
		var primaryCategory  = "Content";
		if (seoTitleTrack.indexOf('Sale & Clearance') >= 0) {
			pageName = "Price Reductions";
			pageIdTrack = "Content: Price Reduction";
		} else if (seoTitleTrack.indexOf('Clearance') >= 0) {
			pageName = "Price Reductions 65Off";                 
			pageIdTrack = "Content: Price Reduction 65Off";
		} else if (seoTitleTrack.indexOf('Limited Availability') >= 0) {
			pageName = "Limited Availability";
			pageIdTrack = "Content: Limited Availability";
		} else if (seoTitleTrack.indexOf('Shop By Brand') >= 0) {
			pageName = "Shop By Brand";
			pageIdTrack = "Content: Shop By Brand";
		} else if (seoTitleTrack.indexOf('Gift Cards') >= 0) {
			pageName = "Gift Cards";
			pageIdTrack = "Content: Gift Cards";
		} else if (seoTitleTrack.indexOf('FAQ - US and International') >= 0) {
			pageName = "FAQ - US and International";
			pageIdTrack = "Content: FAQ - US and International";
		} else if (seoTitleTrack.indexOf('Baby Clothing, Shoes & Accessories') >= 0) {
			pageName = "Baby Checklist";
			pageIdTrack = "Content: Baby Clothing, Shoes & Accessories";
		}
		if(realSearch ==='Y' || trackAsSearch) {
			realSearch = 'Y';
			dataLayer.page.categoryId = "-10005";
			dataLayer.page.name = pageName;
			dataLayer.page.pageId = "SEARCH: Results Successful";
			dataLayer.page.primaryCategory  = primaryCategory;
		} else if(realSearch === 'N' || !trackAsSearch || !realSearch) {
			realSearch = 'N';
			dataLayer.page.categoryId = "-10010";
			dataLayer.page.pageId = pageIdTrack;
			dataLayer.page.name = pageName;
			dataLayer.page.primaryCategory  = primaryCategory;
		};
	}
	if(goTo == 4) {
		if(realSearch === 'Y') {
			realSearch = 'Y';
			dataLayer.page.pageId = "SEARCH: Results Successful";
		} else if(realSearch === 'N') {
			realSearch = 'N';
			dataLayer.page.pageId = pageIdTrack;
		};
	}
};


function getFormattedTS(){

	var date, year, month, day, hour, minute, second;
  
	date   = new Date();
	year   = '' + date.getFullYear();
	month  = '' + (date.getMonth() + 1);
	day    = '' + date.getDate();
	hour   = '' + date.getHours();
	minute = '' + date.getMinutes();
	second = '' + date.getSeconds();
  
	if (month.length < 2)  month  = '0' + month;
	if (day.length < 2)    day    = '0' + day;
	if (hour.length < 2)   hour   = '0' + hour;
	if (minute.length < 2) minute = '0' + minute;
	if (second.length < 2) second = '0' + second;
  
	return month + '.' + day + '.' + year + ' ' + hour + ':' + minute + ':' + second;
}
